<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="license_template"
    :parentId="$route.params.id"
    :customParentData="customParentData"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/license_template";
export default {
  data: () => ({
    modelName: "license_template_version",
    label: "證照公版版本",
    fields: model.fields.last_version.fields,
    customParentData: (modelData, parentModelData) => {
      if (modelData.area) {
        return {
          area: modelData.area.id,
        };
      } else if (parentModelData) {
        if (parentModelData.area) {
          return { area: parentModelData.area.id };
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    hasSequence: true,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "版本內容",
              fields: [
                "statitory_extension_period",
                "recommend_notify_period",
                "training_hours",
                "locales",
                "acts",
              ],
            },
          ],
        },
      ],
      secondary: [],
    },
  }),
};
</script>